<!-- Template -->

<template>  
    <div class="header">
        <h2 class="do-resize" ref="headerTitle">
            Open tickets
        </h2>
        
        <!-- <RequestSupportButton />  -->

    </div>
</template>

<!-- Script -->

<script>
    //import RequestSupportButton from '@/components/RequestSupportButton';

    export default {
        name: 'TicketsHeader',

        // components: {
        //     RequestSupportButton
        // }
    }
</script>

